import { FC } from 'react';
import { Modal } from '@dynamika-shared/ui/Modal/Modal';
import { UserListActionComponentProps } from '../UsersList/UserListActionComponent';
import {
  doUserSuccess,
  useUsersListSlice,
} from '@restore/usersList/usersList.slice';
import { subscribeToActions } from '@restore/store';

type DeactivateUserProps = Pick<
  UserListActionComponentProps,
  'currentUser' | 'refetchUsers'
> & {
  onClose: () => void;
};
export const DeactivateUserConfirmationModal: FC<DeactivateUserProps> = ({
  onClose,
  currentUser,
  refetchUsers,
}) => {
  const [doUserAction, userActionLoading] = useUsersListSlice(
    (state, actions) => [actions.doUser, state.userActionLoading]
  );

  const isDeactivated = !currentUser?.enabled;

  const handleDeactivate = async () => {
    if (currentUser) {
      doUserAction({
        user: currentUser,
        actionName: isDeactivated ? 'reactivateUser' : 'deactivateUser',
      });

      return subscribeToActions(doUserSuccess, () => {
        refetchUsers();
        onClose();
      });
    }
  };

  return (
    <Modal
      confirmLoading={userActionLoading}
      width={440}
      onCancel={() => onClose()}
      onOk={handleDeactivate}
      okText={isDeactivated ? 'Activate' : 'Deactivate'}
      centered
      cancelText='Cancel'
      maskClosable={false}
      open={true}
      mask={false}
      okClassName='ant-btn-dangerous'
      classNames={{
        header: 'text-left !mb-3',
        content: 'text-center !rounded-[2.4rem] !p-[4rem]',
        footer: 'flex justify-between !mt-3',
      }}
      title={isDeactivated ? 'Activate user' : 'Deactivate user'}
      titleClassName='text-left'
      okProps={{
        disabled: userActionLoading,
      }}
      cancelProps={{
        disabled: userActionLoading,
      }}
      data-testid={'deactivateUserModal'}
    >
      Are you sure you want to <br />
      {isDeactivated ? 'activate' : 'deactivate'} this user?
    </Modal>
  );
};
